import { render, staticRenderFns } from "./LunchTickets.vue?vue&type=template&id=3af69a6a&"
import script from "./LunchTickets.vue?vue&type=script&lang=js&"
export * from "./LunchTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports